export function fmtEUR(cents) {
  const amt = (cents || 0) / 100;
  // Show as integer if whole euros
  const opts = amt % 1 === 0
    ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
    : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  return new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", ...opts }).format(amt);
}

export function calcYearlySavings(monthlyCents, yearlyCents) {
  // Yearly = 10x monthly (by config); savings = 12x monthly - yearly
  return Math.max(0, monthlyCents * 12 - yearlyCents);
}

export function tierColor(tier) {
  return { start: "#64748B", pro: "#EA580C", max: "#0F172A" }[tier] || "#0F172A";
}
